export default __webpack_public_path__ + "static/qamcombuilding-7433f494842479aa62ba01d780f9c171.gif";